

import FAQsImageSection from "../PageElements/FAQsPageElements/FAQsImage";
import FAQsMainSection from "../PageElements/FAQsPageElements/FAQsMainSection";
import ServiceSection from "../PageElements/HomePageElements/ServiceSection";
import ConsultSection from "../PageElements/HomePageElements/ConsultSection";
import AskQuestionSection from "../PageElements/ContactPageElement/AskQuestionSection";


export default function FAQsPage() {
    return (
        <>

            <FAQsImageSection />
            <FAQsMainSection/>
            {/* <AskQuestionSection /> */}
            {/* <ServiceSection /> */}
            {/* <ConsultSection /> */}
        </>
    )
}